import { ApeironButtonDisableTip, useAccountContext } from '@apeiron/temp'
import ApeironOperateButton, {
  ApeironOperateButtonProps
} from '@src/components/share/apeiron/ApeironOperateButton'
import { OperateButton } from '@src/constants/variant'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const TradeBuyButton: FC<ApeironOperateButtonProps> = (
  props: ApeironOperateButtonProps
) => {
  const { disableReason, disabled, ...rest } = props

  const { t } = useTranslation()

  const { isLoggedIn } = useAccountContext()

  const notLoggedInReason = t('common.tooltip.disable_buy')

  return (
    <ApeironButtonDisableTip
      disabled={disabled || !isLoggedIn}
      reason={disableReason || notLoggedInReason}
    >
      <ApeironOperateButton
        {...rest}
        variant={OperateButton.BlueShort}
        label={t('common.buy')}
        disabled={disabled || !isLoggedIn}
      />
    </ApeironButtonDisableTip>
  )
}

export default TradeBuyButton
